
export default { name: 'Sticker' };
